import { NextPage } from "next";
import { Seo } from "~/components/seo";
import { Home } from "~/views/home";

const HomePage: NextPage = () => {
	return (
		<>
			<Seo title="Home" />
			<Home />
		</>
	);
};

export default HomePage;
